import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { UpamErrorInterceptor } from '@data/_generated-api/http-interceptors/upam-error.interceptor';
import { DecodingHttpInterceptor } from '@data/_generated-api/http-interceptors/decoding-http.interceptor';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: UpamErrorInterceptor
    },
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: DecodingHttpInterceptor
    }
  ]
})
export class HttpInterceptorsModule {}
